import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FindControlDeleteItemResultDto,
  FindControlInitDto,
  FindControlResultDto,
  GetDataSearchDto, GetMfuSearchDto, GetMruSearchDto,
  IColumnPk,
} from 'webcommon/shared';
import { FindControlRepository } from 'webcommon/webapi';

@Injectable({
  providedIn: 'root',
})
export class ApFindControlService {
  constructor(private findControlRepository: FindControlRepository) { }

  getConfig(id: string): Observable<FindControlInitDto> {
    return this.findControlRepository.getConfig(id);
  }

  getData(id: string, searchDto: GetDataSearchDto): Observable<FindControlResultDto> {
    return this.findControlRepository.getData(id, searchDto);
  }

  getSelectedItems(id: string, guids: string[]): Observable<FindControlResultDto> {
    return this.findControlRepository.getSelectedItems(id, guids);
  }

  getMruList(id: string, maxrows: number, searchDto: GetMruSearchDto): Observable<FindControlResultDto> {
    return this.findControlRepository.getMruList(id, maxrows, searchDto);
  }

  getMfuList(id: string, maxrows: number, searchDto: GetMfuSearchDto): Observable<FindControlResultDto> {
    return this.findControlRepository.getMfuList(id, maxrows, searchDto);
  }

  updateMfuMruList(id: string, guids: string[]): Observable<string[]> {
    return this.findControlRepository.updateMfuMruList(id, guids);
  }

  deleteItem(id: string, controlId: string): Observable<FindControlDeleteItemResultDto> {
    return this.findControlRepository.deleteItem(id, controlId);
  }

  canDeleteItem(id: string, controlId: string): Observable<FindControlDeleteItemResultDto> {
    return this.findControlRepository.canDeleteItem(id, controlId);
  }

  mapFindControlObject<T extends {}>(object: IColumnPk): T | null {
    const newObject: T | null = {} as T;
    Object.assign(newObject, object);

    return newObject;
  }

  mergeItem(id: string, controlId: string, newId: string): Observable<FindControlDeleteItemResultDto> {
    return this.findControlRepository.mergeItem(id, controlId, newId);
  }
}
